import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { connect } from 'react-redux';
import { getIsFetching } from '../reducers/requirements';
import * as actions from '../actions/requirements';
import SitesLayout from './SitesLayout';
import SegmentLoader from 'common/components/SegmentLoader';

const mapStateToProps = state => ({
  isFetching: getIsFetching(state),
});

class CoreLayout extends Component {
  constructor(props, context) {
    super(props, context);

    this._customer = context.data.customer;
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  componentDidMount() {
    const {
      route: { siteCase, isNew },
      fetchRequirements,
    } = this.props;

    fetchRequirements(this._customer, siteCase, isNew);
  }

  _renderChildren(children) {
    return React.cloneElement(children, {
      siteCase: this.props.route.siteCase,
      customer: this._customer,
    });
  }

  render() {
    const { isFetching, children } = this.props;

    if (isFetching) {
      return <SegmentLoader />;
    }

    return (
      <div style={{ height: '100%' }}>
        <SitesLayout
          customer={this._customer}
          children={this._renderChildren(children)}
        />
      </div>
    );
  }
}

CoreLayout.propTypes = {
  route: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
  isFetching: PropTypes.bool.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
};

CoreLayout.contextTypes = {
  data: PropTypes.object.isRequired,
};

CoreLayout.childContextTypes = {
  customer: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, actions)(CoreLayout);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/layouts/CoreLayout.js